<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="h-full rounded shadow-ci">
    <CiSkeletonItem class="block h-48 rounded" />
    <CiSkeletonItem class="my-4 ml-4 block h-14 w-[calc(100%-32px)] rounded" />
  </div>
</template>
